import { type QueryFunctionContext } from '@tanstack/vue-query';
import axios from 'axios';
import { withBase } from 'ufo';

import type { ApiResponse } from '@abaninja/types';

import { unwrap } from '@abaninja/util-http-client';

import { type Version } from '../../@types';

export function getVersion(options?: QueryFunctionContext) {
  return unwrap(axios.get<ApiResponse<Version>>(
    withBase('/version.json', import.meta.env.VITE_NINJA_BASE_PATH),
    {
      signal: options?.signal,
      headers: {
        'Cache-Control': 'no-cache',
        'Expires': '0',
        'Pragma': 'no-cache',
      },
    },
  ));
}
